import { Outlet } from 'react-router-dom';
import { AiBalanceBanner } from './AiBalanceBanner';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { BottomNavBar } from './BottomNavBar';
import { NotificationCenter } from './NotificationCenter';
import { EntityDetailPanel } from '../shared/EntityDetailPanel';
import { ForcePasswordChange } from './ForcePasswordChange';
import { AiChatPanel } from '../shared/AiChatPanel';
import { useUIStore } from '../../stores/uiStore';

export function Layout() {
  const { sidebarCollapsed } = useUIStore();

  return (
    <div className="min-h-screen bg-[var(--color-bg)]">
      <Sidebar />
      <div
        className={`transition-all duration-300 ${
          sidebarCollapsed
            ? 'lg:ml-[var(--sidebar-collapsed-width)]'
            : 'lg:ml-[var(--sidebar-width)]'
        }`}
      >
        <TopBar />
        <main className="p-4 lg:p-6 pb-20 lg:pb-6">
          <AiBalanceBanner />
          <Outlet />
        </main>
      </div>
      <BottomNavBar />
      <NotificationCenter />
      <EntityDetailPanel />
      <AiChatPanel />
      {/* Tapa todo el sistema mientras el usuario no cambie la contraseña que le dieron. */}
      <ForcePasswordChange />
    </div>
  );
}
